import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { AppShell } from '../components/AppShell';
import { YourAgentsBody } from '../components/symphony/agents/YourAgentsBody';
import { useNarrow } from '../lib/use-narrow';
import { useMyAgents } from '../lib/my-agents';
import { useTranslation } from '../lib/i18n';
import { usePageLoadBi } from '../lib/use-page-load-bi';
import { homeShowsAgentsItself, useHomeVariantGate } from '../lib/home-variant';
import { MapHome } from '../components/symphony/home2/map/MapHome';

// "Your Agents" — the team the Maestro leads. Shows the genome beside the agent
// card pile (Figma `10261:86167`).
export default function AgentsPage() {
  // Only the AGENTS WORLD home replaces Your Agents — the same screen, opened with the camera on the
  // agents ring (docs/claude/home2-map.md). The ACTIVITY MAP home does NOT: its agents are dots on a
  // ring, a summary, so its readers keep the real Your Agents page (and the rail keeps its entry).
  //
  // The page-view waits for the gates to answer so it is reported under the name of the screen actually
  // shown, and it is fired HERE only for the Your Agents branch — the map reports its own `map_home`
  // from `MapHome`, so firing both would double-count the visit.
  const { variant, resolved } = useHomeVariantGate();
  const agentsIsHome = homeShowsAgentsItself(variant);
  usePageLoadBi({ page_name: 'your_agents' }, { enabled: resolved && !agentsIsHome });
  const narrow = useNarrow();
  const { t } = useTranslation();

  // With no team the intro takes over the whole screen and carries its own title, so the
  // page header is dropped — matching the empty frame (Figma `10941:75358`), which has no
  // "Your Agents" heading above the illustration.
  const agents = useMyAgents();
  const empty = agents.status === 'ready' && agents.team.agents.length === 0;
  // AppFrame drops its top-bar island on this route on that home (`pillOnTopBar`), so the map's own
  // header carries it, as on `/`.

  // The narrow screen renders its own header — a 32px title sitting tight to the task
  // strip beneath it, rather than AppShell's 40px page header and its 48px gap to
  // content — so there it takes AppShell as a pure layout wrapper.
  if (agentsIsHome)
    return (
      <GenericEventsRouteProvider value="agents">
        <AppShell title="" fluid>
          {/* `view` is explicit: the default is the ACTIVITY map, which is a different home entirely
              and would render the wrong screen here. */}
          <MapHome landOn="agents" view="agents-world" />
        </AppShell>
      </GenericEventsRouteProvider>
    );

  return (
    <GenericEventsRouteProvider value="agents">
      <AppShell title={narrow || empty ? '' : t('agents.title')}>
        <YourAgentsBody />
      </AppShell>
    </GenericEventsRouteProvider>
  );
}
